import React, { createRef, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Radio, Tab, TableCell, Tabs, TextField, Typography } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import MUIDataTable from 'mui-datatables';
import AddIcon from '@material-ui/icons/Add';
import CloseImage from '../../assets/ic_close.png';
import IconArrow from '../../assets/ic_arrow.png';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ComponentToPrint } from './ComponentToPrint';
import { ComponentResep } from './ComponentResep';
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import { format } from 'date-fns';
import Loader from 'react-loader-spinner'
import ReactDOM from 'react-dom'
import editIcon from '../../assets/ic_detail.png';
import ErrorRequest from '../ErrorRequest';
import { useLocation } from 'react-router';
import { usePrevious } from '../../library/Util';
import { withStyles } from '@material-ui/styles';
import { green } from '@material-ui/core/colors';
import { ComponentTiket } from './ComponentTiket';
import { ComponentAutoPrint } from './ComponentAutoPrint';
import Constant from '../../library/Constant';
import Pusher from 'pusher-js';
// import CloseImage from '../../assets/ic_close.png';

const pageStyle = `{size: 3.075in 150mm}`;
const pageStyleTiket = `{size: 5cm 7.3cm}`;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

const style = {
    position: "sticky",
    zIndex: 110
};

export default function FarmasiDalam(props) {
    const componentRef = useRef()
    const componentEtik = useRef()
    const componentResep = useRef()
    const componentAutoPrint = useRef()
    const inputElement = useRef(null)
    const location = useLocation()
    const classes = useStyles()
    const [noAntri, setNoAntri] = React.useState("");
    const [namaPasien, setNamaPasien] = React.useState(null)
    const [kodePesanan, setKodePesanan] = React.useState(null)
    const [noRM, setNoRM] = React.useState("")
    const [notes, setNotes] = React.useState("")
    const [newNotes, setNewNotes] = React.useState("")
    const [rowData, setRowData] = React.useState(new Date())
    const [value, setValue] = React.useState(0);//
    const [visible, setVisible] = React.useState(false)
    const [addCatatan, setAddCatatan] = React.useState(false)
    const [listLokasi, setListLokasi] = React.useState([])
    const [visibleStatus, setVisibleStatus] = React.useState(false)
    const [visibleStatusBatal, setVisibleStatusBatal] = React.useState(false)
    const [visibleEdit, setVisibleEdit] = React.useState(false)
    const [visibleEticket, setVisibleEticket] = React.useState(false)
    const [lokasi, setLokasi] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [dataAntrian, setDataAntrian] = React.useState([])
    const [rawData, setRawData] = React.useState([])
    const [statusAntrian, setStatusAntrian] = React.useState("")
    const [list, setList] = React.useState([])
    const [facility_id, setFacilityID] = React.useState("")
    const [facility_queue_id, setFacilityQueueID] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [visibleError, setVisibleError] = React.useState(false)
    const [visiblePrint, setVisiblePrint] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState("")
    const prevCount = usePrevious(list);
    const [dataLama, setDataLama] = useState([])
    const [dataBaru, setDataBaru] = useState([])
    const [detail, setDetail] = useState([])
    const [detailResep, setDetailResep] = useState(null)
    const [idxCheck, setidxCheck] = useState([])
    const [listPrinting, setListPrinting] = useState([])
    const [idPrint, setIDPrint] = useState([])
    const [buttonRecipe, setButtonRecipe] = useState(false)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const wrapperRef = React.createRef()

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }

    // useEffect(() => {
    //     console.log(localStorage.getItem);
    //     props.setShowNotif(false)
    //     const pusher = new Pusher(Constant.PUSHER_APP_KEY, {
    //         cluster: Constant.PUSHER_APP_CLUSTER,
    //         encrypted: true
    //     });
    //     const api_key = localStorage.getItem(Constant.API_KEY)
    //     const channel = pusher.subscribe(`medapp-web-admin-pharmacy-production-list-${api_key}-${location.state.id}`);
    //     console.log(channel);
    //     channel.bind(`pharmacy-production-list-${location.state.id}`, data => {
    //         console.log(data);
    //         if (data && data.is_hit) {
    //             getDataTable()
    //         }
    //     });
    //     getListCounter()
    //     getDataTable()
    // }, [])

    useEffect(() => {
        if (list.length != (prevCount !== undefined ? prevCount.length : -1)) {
            getListCounter()
            getDataTable()
        }
        const interval = setInterval(() => {
            getDataTable()
        }, 3000);
        return () => clearInterval(interval);
    }, [dataBaru])

    const getData = () => {
        if (props.skip === false) {
            api.create().getPharmacyProductionByFacilityID(location.state.id).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data) {
                        setDataLama(response.data.data)
                        setDataBaru(response.data.data)
                    }
                }
            })
        }
    }

    const getDataTable = () => {
        api.create().getPharmacyProductionByFacilityID(location.state.id).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data) {
                    if (response.data.data.length > 0) {
                        let a = response.data.data.filter(elm => !dataLama.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                        // console.log(a);
                        if (a.length > 0) {
                            getData()
                            getListCounter()
                        }
                    } else {
                        setDataBaru([])
                        setDataLama([])
                    }
                    setDataBaru(response.data.data)
                }
            }
        })
    }

    const getListCounter = () => {
        console.log(location);
        api.create().getPharmacyProductionByFacilityID(location.state.id).then(response => {
            console.log(response);
            let listCounter = []
            let listPrinting = []
            if (response.data) {
                let idPrint = []
                response.data.data.map((el, idx) => {
                    listCounter.push({
                        "no": idx + 1,
                        "antrian": el.queue_number,
                        "tanggalProduksi": el.production_date,
                        "kodePesanan": el.booking_id,
                        "name": el.patient_name === null ? el.patient_name_2 : el.patient_name,
                        "proses": el.start_process,
                        "status": el.status === 0 ? "Batal" : el.status === 1 ? "Belum Diproduksi" : el.status === 2 ? "Produksi" : el.status === 3 ? "Selesai" : el.status === 5 ? "Pembayaran Dibatalkan" : "Diterima Pasien",
                        "idResep": null,
                        "id": el.id,
                        "medical_record": el.patient_medical_record_no === null ? el.patient_medical_record_no_2 : el.patient_medical_record_no,
                        "lokasi": el.location,
                    })
                    if (el.print_times === 0) {
                        listPrinting.push(el)
                        idPrint.push(el.id)
                    }
                })
                console.log(listCounter);
                listCounter.sort((a, b) => b - a)
                setList(listCounter)
                setListPrinting(listPrinting)
                setDataLama(response.data.data)
                setIDPrint(idPrint)
                setTimeout(() => {
                    if (listPrinting.length > 0) {
                        setVisiblePrint(true)
                        setTimeout(() => {
                            if (inputElement.current !== null) {
                                inputElement.current.click();
                            }
                        }, 1000);
                    }
                }, 300);
            }
            setLoading(false)
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleStart = ({ rowData }) => {
        console.log(rowData);
        let payload = {
            "id": rowData[rowData.length - 2],
            "status": 2
        }
        setVisibleStatus(true)
        setRowData(payload)
        // api.create().changeStatusProduksi(payload).then(response => {
        //     console.log(response);
        //     getListCounter()
        // })
    }

    const handleSelesai = ({ rowData }) => {
        console.log(rowData);
        let payload = {
            "id": rowData[rowData.length - 3],
            "status": 3
        }
        setVisibleStatus(true)
        setRowData(payload)
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const handleEdit = ({ rowData }) => {
        console.log(rowData);
        api.create().getDetailPharmacyProduction(rowData[9]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setLokasi(data.facility.name)
                    setNamaPasien(data.patient_name === null ? data.patient_name_2 : data.patient_name)
                    setKodePesanan(data.booking_id)
                    setNoAntri(data.queue_number)
                    setNoRM(data.patient_medical_record_no === null ? data.patient_medical_record_no_2 : data.patient_medical_record_no)
                    if (response.data.data.recipes.length > 0) {
                        getDetailResep(response.data.data.recipes[0].id)
                    } else {
                        setVisibleEdit(true)
                        // setButtonRecipe(false)
                    }
                }
            }
        })
        // getDetailResep(rowData)
    }

    const onClose = () => {
        setVisibleStatus(false)
        setVisibleStatusBatal(false)
        setVisibleEdit(false)
    };

    const changeStatus = () => {
        setVisibleStatus(false)
        setLoading(true)
        api.create().changeStatusProduksi(rowData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    getListCounter()
                } else {
                    setVisibleError(true)
                    // setErrorMessage(response.data.data)
                }
                setLoading(false)
            }
        })
    }

    const changeStatusBatal = () => {
        console.log(detail);
        let payload = {
            "id": detail[detail.length - 3],
            "status": 0
        }
        // setLoading(true)
        api.create().changeStatusProduksi(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setVisibleStatusBatal(false)
                    getListCounter()
                } else {
                    setVisibleError(true)
                    setErrorMessage(response.data.data)
                }
                setLoading(false)
            }
        })
    }

    const getDetailResep = (id) => {
        api.create().getDetailResep(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.data.length > 0) {
                    setDetailResep(response.data.data && response.data.data[0])
                    setButtonRecipe(true)
                } else {
                    // alert(response.data.message)
                }
                setVisibleEdit(true)
                setRowData(rowData)
            }
        })
    }

    const handleClickPrint = (e) => {
        if (inputElement.current !== null) {
            inputElement.current.focus();
        }
    }

    const updatePrint = () => {
        let payload = {
            "pharmacy_production_id": idPrint
        }
        api.create().updateCountPrint(payload).then(response => {
            console.log(response);
        })
    }

    const columns = [
        {
            name: 'no',
            label: 'No',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'antrian',
            label: 'No. Antrian',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'tanggalProduksi',
            label: 'Tanggal',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'kodePesanan',
            label: 'ID Reservasi',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'name',
            label: 'Nama Pasien',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'proses',
            label: 'Jam Transaksi',
            options: {
                sort: true,
                sortThirdClickReset: true,
            }
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                sortThirdClickReset: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <Typography>{val}</Typography>
                    )
                }
            }
        },
        {
            name: 'idResep',
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "Aksi",
            options: {
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {
                                tableMeta.rowData[6] === "Selesai" || tableMeta.rowData[6] === "Diterima Pasien" || tableMeta.rowData[6] === "Batal" ?
                                    <div style={{ justifyContent: 'space-between' }}>
                                        <button
                                            onClick={() => handleEdit(tableMeta)}
                                            style={{
                                                backgroundColor: "transparent",
                                                fontSize: 20,
                                                outline: 'none',
                                                borderColor: 'transparent',
                                                marginRight: 20
                                            }}>
                                            <img src={editIcon} style={{ width: 30, height: 30 }} />
                                        </button>
                                    </div>
                                    :
                                    tableMeta.rowData[6] === "Produksi" ?
                                        <div>
                                            <button
                                                id='btn'
                                                style={{ borderColor: 'transparent', backgroundColor: '#4cdc63', borderRadius: 20, width: 100, marginLeft: 10 }}
                                                onClick={() => handleSelesai(tableMeta)}
                                            >
                                                <Typography style={{ color: 'white' }}>Selesai</Typography>
                                            </button>
                                            <button
                                                onClick={() => handleEdit(tableMeta)}
                                                style={{
                                                    backgroundColor: "transparent",
                                                    fontSize: 20,
                                                    outline: 'none',
                                                    borderColor: 'transparent',
                                                    marginRight: 20
                                                }}>
                                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                                            </button>
                                        </div>
                                        :
                                        tableMeta.rowData[6] === "Belum Diproduksi" ?
                                            <div>
                                                <button
                                                    id='btn'
                                                    style={{ borderColor: 'transparent', backgroundColor: '#4cdc63', borderRadius: 20, width: 100, marginLeft: 10 }}
                                                    onClick={() => handleSelesai(tableMeta)}
                                                >
                                                    <Typography style={{ color: 'white' }}>Selesai</Typography>
                                                </button>
                                                <button
                                                    onClick={() => handleEdit(tableMeta)}
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        fontSize: 20,
                                                        outline: 'none',
                                                        borderColor: 'transparent',
                                                        marginRight: 20
                                                    }}>
                                                    <img src={editIcon} style={{ width: 30, height: 30 }} />
                                                </button>
                                            </div>
                                            :
                                            tableMeta.rowData[6] === "Pembayaran Dibatalkan" ?
                                                <div>
                                                    <button
                                                        id='btn'
                                                        style={{ borderColor: 'transparent', backgroundColor: '#ff5b5b', borderRadius: 20, width: 100, marginLeft: 10 }}
                                                        onClick={() => {
                                                            setDetail(tableMeta.rowData)
                                                            setVisibleStatusBatal(true)
                                                        }}
                                                    >
                                                        <Typography style={{ color: 'white' }}>Batal</Typography>
                                                    </button>
                                                </div>
                                                :
                                                <div>
                                                    <button
                                                        id='btn'
                                                        style={{ borderColor: 'transparent', backgroundColor: '#4cdc63', borderRadius: 20, width: 100, marginLeft: 10 }}
                                                        onClick={() => handleSelesai(tableMeta)}
                                                    >
                                                        <Typography style={{ color: 'white' }}>Selesai</Typography>
                                                    </button>
                                                    <button
                                                        onClick={() => handleSelesai(tableMeta)}
                                                        style={{
                                                            backgroundColor: "transparent",
                                                            fontSize: 20,
                                                            outline: 'none',
                                                            borderColor: 'transparent',
                                                            marginRight: 20
                                                        }}>
                                                        <img src={editIcon} style={{ width: 30, height: 30 }} />
                                                    </button>
                                                </div>
                            }
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "medical_record",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "lokasi",
            options: {
                display: false,
                filter: false
            }
        },
    ];

    return (
        <div>
            <Paper style={{ boxShadow: 'none' }} >
                <div style={{ width: '100%', display: 'grid' }}>
                    {loading && (loadingComponent)}
                </div>
            </Paper>
            <div style={{}}>
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={list}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </Paper>
            </div>
            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => onClose()}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Produksi tersebut?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => onClose()}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleStatusBatal && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => onClose}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin membatalkan Produksi tersebut?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => onClose()}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatusBatal()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {
                visibleEdit ?
                    <div className="App app-popup-show">
                        <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8, backgroundColor: '#278863' }}>
                                <div style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'white', fontSize: 18, marginLeft: 20 }}>Proses Produksi</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => onClose()}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div className={"nav__body"} style={{ backgroundColor: 'white', height: '100%', width: '100%', borderBottomRightRadius: 8, borderBottomLeftRadius: 8 }}>
                                <div style={{ padding: 20, display: 'flex', justifyContent: 'flex-end' }}>
                                    <button style={{ outline: 'none', backgroundColor: 'transparent', borderColor: 'transparent' }} onClick={() => setAddCatatan(true)}>
                                        <Typography style={{ marginBottom: 10, fontWeight: 'bold', color: '#0066ff', textAlign: 'right', fontSize: 16 }}>+ Tambah Catatan</Typography>
                                    </button>
                                </div>
                                <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="noAntri"
                                        disabled={true}
                                        name="noAntri"
                                        label="No. Antrian"
                                        placeholder={"input No. Antrian"}
                                        value={noAntri}
                                        onChange={(e) => {
                                            // setNamaPasien(e.target.value)
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="kode"
                                        disabled={true}
                                        name="kode"
                                        label="Kode Reservasi"
                                        placeholder={"input Kode reservasi"}
                                        value={!kodePesanan ? "-" : kodePesanan}
                                        onChange={(e) => {
                                            // setNamaPasien(e.target.value)
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30, paddingBottom: !buttonRecipe ? 60 : 0 }}>
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="nama"
                                        disabled={true}
                                        name="nama"
                                        label="Nama Pasien"
                                        placeholder={"input Nama Pasien"}
                                        value={!namaPasien ? "-" : namaPasien}
                                        onChange={(e) => {
                                            // setNamaPasien(e.target.value)
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div>
                                {/* <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="catatan"
                                        disabled={true}
                                        name="catatan"
                                        label="Catatan"
                                        placeholder={"input Catatan"}
                                        value="-"
                                        onChange={(e) => {
                                            setNamaPasien(e.target.value)
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                                fontFamily: 'Nunito Sans, sans-serif',
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </div> */}
                                {addCatatan && (
                                    <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30, display: 'flex' }}>
                                        <TextField
                                            style={{ width: '100%', marginTop: 7 }}
                                            id="catatanBaru"
                                            name="catatanBaru"
                                            label="Catatan Petugas"
                                            placeholder={"input catatan petugas"}
                                            value={newNotes}
                                            onChange={(e) => {
                                                setNewNotes(e.target.value)
                                                forceUpdate()
                                            }}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                    fontFamily: 'Nunito Sans, sans-serif',
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {

                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            style={{ borderColor: 'transparent', outline: 'none', marginTop: 10 }}
                                            onClick={() => setAddCatatan(false)}
                                        >
                                            <div style={{ width: 24, height: 24, backgroundColor: '#278863', borderRadius: 15 }}>
                                                <img src={CloseImage} style={{ width: 12, height: 12 }} />
                                            </div>
                                        </button>
                                    </div>
                                )}
                                {/* {buttonRecipe && ( */}
                                {/* <div style={{ marginTop: 50, display: 'flex', justifyContent: 'space-evenly', paddingBottom: 20, borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}> */}
                                    {buttonRecipe ?
                                        <div style={{ marginTop: 50, display: 'flex', justifyContent: 'space-evenly', paddingBottom: 20, borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                                            <div>
                                                <ReactToPrint
                                                    pageStyle={pageStyle}
                                                    trigger={() => {
                                                        return (
                                                            <div
                                                                style={{ height: 30, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', padding: '5px 20px' }}
                                                            >
                                                                <Typography style={{ fontSize: '14px', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Cetak Resep</Typography>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => componentResep.current}
                                                >
                                                    <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Reservasi</Typography>
                                                </ReactToPrint>
                                                <div style={{ display: 'none' }}>
                                                    <ComponentResep
                                                        noAntrian={rowData[1]}
                                                        kodePesanan={rowData[3]}
                                                        namaPasien={rowData[4]}
                                                        status={rowData[6]}
                                                        medicalRecord={rowData[9]}
                                                        lokasi={lokasi}
                                                        detailResep={detailResep}
                                                        // tipeAntrian={this.state.tipeAntrian}
                                                        // regisAntrian={this.state.regisAntrian}
                                                        ref={componentResep}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <ReactToPrint
                                                    pageStyle={pageStyle}
                                                    trigger={() => {
                                                        return (
                                                            <div
                                                                style={{ height: 30, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', padding: '5px 20px' }}
                                                            >
                                                                <Typography style={{ fontSize: '14px', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Cetak Antrian</Typography>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => componentRef.current}
                                                >
                                                    <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Reservasi</Typography>
                                                </ReactToPrint>
                                                <div style={{ display: 'none' }}>
                                                    <ComponentToPrint
                                                        noAntrian={noAntri}
                                                        kodePesanan={kodePesanan}
                                                        namaPasien={namaPasien}
                                                        status={rowData[6]}
                                                        medicalRecord={noRM}
                                                        lokasi={lokasi}
                                                        detailResep={detailResep}
                                                        // tipeAntrian={this.state.tipeAntrian}
                                                        // regisAntrian={this.state.regisAntrian}
                                                        ref={componentRef}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ height: 30, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', padding: '5px 20px' }}
                                                onClick={() => {
                                                    setVisibleEticket(true)
                                                    setVisibleEdit(false)
                                                }}
                                            >
                                                <Typography style={{ fontSize: '14px', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Cetak Etiket</Typography>
                                            </div>
                                        </div>
                                        :
                                        <div style={{ marginTop: 50, display: 'flex', justifyContent: 'space-evenly', paddingBottom: 20, borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                                            <div>
                                                <ReactToPrint
                                                    pageStyle={pageStyle}
                                                    trigger={() => {
                                                        return (
                                                            <div
                                                                style={{ height: 30, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', padding: '5px 20px' }}
                                                            >
                                                                <Typography style={{ fontSize: '14px', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Cetak Antrian</Typography>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => componentRef.current}
                                                >
                                                    <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Reservasi</Typography>
                                                </ReactToPrint>
                                                <div style={{ display: 'none' }}>
                                                    <ComponentToPrint
                                                        noAntrian={noAntri}
                                                        kodePesanan={kodePesanan}
                                                        namaPasien={namaPasien}
                                                        status={rowData[6]}
                                                        medicalRecord={noRM}
                                                        lokasi={lokasi}
                                                        detailResep={detailResep}
                                                        // tipeAntrian={this.state.tipeAntrian}
                                                        // regisAntrian={this.state.regisAntrian}
                                                        ref={componentRef}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                {/* </div> */}
                                {/* )} */}
                                {/* <div style={{ marginTop: 30, display: 'flex', justifyContent: 'center' }}>
                                    
                                </div> */}
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                visibleError ?
                    <ErrorRequest
                        message={errorMessage}
                        close={() => setVisibleError(false)}
                    />
                    : null
            }

            {visibleEticket && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, margin: 'auto', overflow: 'auto', width: 800 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8, backgroundColor: '#f5f5f5' }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Cetak Etiket</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleEticket(false)
                                        setVisibleEdit(true)
                                    }}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: '20px' }}>
                            {detailResep && detailResep.detail.length > 0 && (
                                <div>
                                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderBottomColor: '#bdc3c7', marginBottom: 5 }}>
                                        <div style={{ display: 'flex', width: '10%' }}>
                                            <Typography style={{ fontSize: 'bold' }}>No</Typography>
                                        </div>
                                        <div style={{ display: 'flex', width: '40%' }}>
                                            <Typography style={{ fontSize: 'bold' }}>Nama Obat</Typography>
                                        </div>
                                        <div style={{ display: 'flex', width: '40%' }}>
                                            <Typography style={{ fontSize: 'bold' }}>Jenis Obat</Typography>
                                        </div>
                                        <div style={{ display: 'flex', width: '10%' }}>
                                            <Typography style={{ fontSize: 'bold' }}>Aksi</Typography>
                                        </div>
                                    </div>
                                    {detailResep.detail.map((item, index) => {
                                        return (
                                            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', margin: '10px 0px' }}>
                                                <div style={{ display: 'flex', width: '10%' }}>
                                                    <Typography>{index + 1}</Typography>
                                                </div>
                                                <div style={{ display: 'flex', width: '40%' }}>
                                                    <Typography style={{ textAlign: 'left' }}>{item.name}</Typography>
                                                </div>
                                                <div style={{ display: 'flex', width: '40%' }}>
                                                    <Typography>{item.medicine_type}</Typography>
                                                </div>
                                                <div style={{ display: 'flex', width: '10%' }}>
                                                    <GreenRadio
                                                        title="Pilih"
                                                        checked={idxCheck && idxCheck.includes(item) ? true : false}
                                                        onClick={() => {
                                                            let idx = idxCheck.findIndex((val) => val.id === item.id)
                                                            if (idx > -1) {
                                                                idxCheck.splice(idx, 1)
                                                                forceUpdate()
                                                            } else {
                                                                idxCheck.push(item)
                                                                forceUpdate()
                                                            }
                                                        }}
                                                        // value="c"
                                                        name="radio"
                                                        style={{ padding: 0 }}
                                                        inputProps={{ 'aria-label': 'C' }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {/* <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div> */}
                                {idxCheck.length > 0 && (
                                    <div>
                                        <ReactToPrint
                                            pageStyle={pageStyleTiket}
                                            onBeforePrint={null}
                                            onAfterPrint={() => setidxCheck([])}
                                            trigger={() => {
                                                return (
                                                    <div
                                                        style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    >
                                                        <Typography style={{ fontSize: '15px', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Cetak</Typography>
                                                    </div>
                                                )
                                            }}
                                            content={() => componentEtik.current}
                                        >
                                            <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Priaant Reservasi</Typography>
                                        </ReactToPrint>
                                        <div style={{ display: 'none' }}>
                                            <ComponentTiket
                                                idxCheck={idxCheck}
                                                detailResep={detailResep}
                                                ref={componentEtik}
                                            />
                                        </div>
                                    </div>
                                )}
                                {/* <div onClick={(e) => handlePrintTiket()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Cetak</Typography>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visiblePrint && (
                <div>
                    <ReactToPrint
                        pageStyle={pageStyle}
                        onAfterPrint={() => {
                            setVisiblePrint(false)
                            updatePrint()
                        }}
                        trigger={(e) => {

                            return (
                                <div className="App app-popup-show">
                                    <div>
                                        <div className="" style={{ padding: '3% 5%' }}
                                            onClick={handleClickPrint}
                                            ref={inputElement}
                                        >
                                        </div>
                                    </div>
                                </div>
                            )
                        }}
                        content={() => componentAutoPrint.current}
                    >
                        <Typography style={{ fontSize: '2.4vh', fontFamily: 'Poppins', fontWeight: '500', color: '#ffffff', textAlign: 'center' }}>Print Reservasi</Typography>
                    </ReactToPrint>
                    <div style={{ display: 'none' }}>
                        <ComponentAutoPrint
                            listPrinting={listPrinting}
                            // tipeAntrian={this.state.tipeAntrian}
                            // regisAntrian={this.state.regisAntrian}
                            ref={componentAutoPrint}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}